import { ConfigProvider, message, Spin } from 'antd';
import { ConfigProvider as ConfigProviderV5 } from 'antd-v5';
import { useMount } from 'ahooks';
import { IntlProvider } from 'react-intl';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import type { Dispatch, RootState } from './models/store';
import HomeHeader from './components/Layout';
import { routes } from './router';
import langMap from './locales/langMap';
import Bridge from './utils/bridge';
import { isEmpty } from 'lodash';
import { CacheRoutes, Router } from 'xui-pro/es/Layout/CacheRouter';
import { addUsingPost } from './api/sip/user/addUsingPost';
import ChooseLangDrawer from './components/ChooseLangDrawer';
import { useEffect, useState } from 'react';

export const APP_ROOT = 'SIP_ROOT';
export const getAppRootDom = () => document.getElementById(APP_ROOT)!;

window.xDragonBridge = new Bridge();

export default () => {
  const locale: string = useSelector<RootState, string>(
    state => state.LocaleModel.localLang,
    shallowEqual
  );
  const baseRoute: string = useSelector<RootState, string>(
    state => state.LocaleModel.baseRoute,
    shallowEqual
  );

  const dispatch = useDispatch<Dispatch>();
  const forceChooseLang: any = useSelector<RootState>(
    state => state.LocaleModel.forceChooseLang,
    shallowEqual
  );

  const [localeData, setLocaleData] = useState<{
    locale: any;
    antd: any;
    antdV5: any;
  } | null>(null);

  useMount(() => {
    // 设置全局消息上间距，避免遮挡页签
    message.config({ top: 54, getContainer: getAppRootDom });
    // 初始化环境
    dispatch.GlobalModel.initEnv();
    // 初始化语言
    dispatch.LocaleModel.fetchContryLang();
    // 初始化用户数据
    dispatch.UserModel.fetchCurrent();
    // 注册C端用户
    addUsingPost();
  });

  useEffect(() => {
    const getLocalData = async () => {
      if (locale) {
        const [localeModule, antdModule, antdV5Module] = await Promise.all([
          langMap[locale].locale(),
          langMap[locale].antd(),
          langMap[locale].antdV5()
        ]);
        setLocaleData({
          locale: localeModule,
          antd: antdModule,
          antdV5: antdV5Module
        });
      }
    };
    getLocalData();
  }, [locale]);

  if (forceChooseLang) {
    return <ChooseLangDrawer drawerVisible={true} closable={false} />;
  }

  if (isEmpty(locale) || isEmpty(baseRoute) || !localeData) {
    return (
      <div
        style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <Spin spinning={true} />
      </div>
    );
  }

  return (
    <div id='SIP_ROOT'>
      <IntlProvider
        messages={localeData.locale}
        locale={window.navigator.language}
        defaultLocale='en'
      >
        <ConfigProviderV5 locale={localeData.antdV5}>
          <ConfigProvider locale={localeData.antd}>
            <Router routerProps={{ basename: baseRoute }}>
              <HomeHeader>
                <CacheRoutes
                  routes={routes}
                  hasLoading={true}
                  cacheKey={props => props.location?.pathname as string}
                  multipleCacheKey={props => props.location?.pathname as string}
                />
              </HomeHeader>
            </Router>
          </ConfigProvider>
        </ConfigProviderV5>
      </IntlProvider>
    </div>
  );
};
